import {
  faAlignJustify,
  faCalendar,
  faCircleDot,
  faEnvelope,
  faFont,
  faGrip,
  faHashtag,
  faHeading,
  faPenToSquare,
  faSignature,
  faSquareCaretDown,
  faSquareCheck,
  faUpDown,
  faUpload,
} from '@fortawesome/free-solid-svg-icons'

export const initialOptions = [
  { id: 1, label: 'First Choice', checked: true },
  { id: 2, label: 'Second Choice', checked: false },
  { id: 3, label: 'Third Choice', checked: false },
]

export const headingSize = {
  H1: '40px',
  H2: '32px',
  H3: '28px',
  H4: '24px',
  H5: '20px',
  H6: '16px',
}

export const fieldIcon = {
  heading: faHeading,
  paragraph: faAlignJustify,
  text: faFont,
  number: faHashtag,
  textarea: faPenToSquare,
  checkbox: faSquareCheck,
  radio: faCircleDot,
  select: faSquareCaretDown,
  email: faEnvelope,
  date: faCalendar,
  upload: faUpload,
  signature: faSignature,
  matrix: faGrip,
  spacer: faUpDown,
}

export const textInputTypes = ['text', 'tel', 'url']
export const dateInputTypes = [
  'date',
  'datetime',
  'datetime-local',
  'time',
  'month',
  'week',
]

export const formFields = [
  { type: 'heading', text: 'Heading', fontSize: 'H3' },
  { type: 'paragraph', text: 'Paragraph' },
  {
    type: 'text',
    text: 'Text Field',
    label: 'Text Field',
    inputType: 'text',
    placeholder: '',
    value: '',
    helpText: '',
    min: null,
    max: null,
    required: false,
    readOnly: false,
    disabled: false,
  },
  {
    type: 'number',
    text: 'Number Field',
    label: 'Number Field',
    placeholder: '',
    value: null,
    helpText: '',
    min: null,
    max: null,
    required: false,
    readOnly: false,
    disabled: false,
  },
  {
    type: 'date',
    text: 'Date Field',
    label: 'Date Field',
    placeholder: '',
    value: null,
    helpText: '',
    required: false,
    readOnly: false,
    disabled: false,
  },
  {
    type: 'email',
    text: 'Email Field',
    label: 'Email Field',
    inputType: 'email',
    placeholder: '',
    value: null,
    helpText: '',
    min: null,
    max: null,
    required: false,
    readOnly: false,
    disabled: false,
  },
  {
    type: 'textarea',
    text: 'Text Area',
    label: 'Text Area',
    placeholder: '',
    value: '',
    helpText: '',
    rows: 3,
    min: null,
    max: null,
    required: false,
    readOnly: false,
    disabled: false,
  },
  {
    type: 'upload',
    inputType: 'attach',
    text: 'Attach File',
    label: 'Admin Attached File',
    accept: '.gif, .jpg, .png, .pdf, .doc, .docx, .txt',
    helpText: '',
    fileName: '',
    filePath: '',
    fileSize: 0,
    required: false,
    readOnly: false,
    disabled: false,
  },
  {
    type: 'upload',
    text: 'File Upload',
    label: 'Upload a File',
    accept: '.gif, .jpg, .png',
    helpText: '',
    min: null,
    max: null,
    required: false,
    readOnly: false,
    disabled: false,
  },
  {
    type: 'checkbox',
    text: 'Checkboxes',
    label: 'Check All That Apply',
    helpText: '',
    options: initialOptions,
    required: false,
    readOnly: false,
    disabled: false,
  },
  {
    type: 'radio',
    text: 'Radio Buttons',
    label: 'Select a Choice',
    helpText: '',
    options: initialOptions,
    required: false,
    readOnly: false,
    disabled: false,
  },
  {
    type: 'select',
    text: 'Select List',
    options: initialOptions,
    label: 'Select a Choice',
    required: false,
    readOnly: false,
    disabled: false,
    helpText: '',
  },
  {
    type: 'signature',
    text: 'Signature',
    label: 'Signature',
    helpText: '',
    width: 400,
    height: 200,
  },
  // {
  //   type: 'matrix',
  //   text: 'Matrix Field',
  //   label: 'Answer the following questions',
  //   placeholder: '',
  //   value: '',
  //   helpText: '',
  //   rows: 3,
  //   min: null,
  //   max: null,
  //   required: false,
  //   readOnly: false,
  //   disabled: false,
  // },
  // {
  //   type: 'spacer',
  //   text: 'Spacer',
  //   label: 'Spacer',
  //   height: 50,
  // },
]
